import api from './api';

var videoTypes=window.appData.videoTypes;

export default {
  data: ()=>({
//     menuOpen: false,
//     menuSubOpen: null,
    menuItems: [
      {link: {name: "home"}, title: "All"},
      {link: {name: "category", params: {category: "mat"}}, title: "Mat"},
      {link: {name: "category", params: {category: "aparatus"}}, title: "Apparatus"},
      {link: {name: "category", params: {category: "workshop"}}, title: "Workshop"},
      {link: {name: "category", params: {category: "krn-quickies"}}, title: "Quickies"},
      {link: {name: "category", params: {category: "ppatt"}}, title: "PPATT"},
      {link: {name: "packages"}, title: "Subscriptions", loggedIn: true},
    ],
    tags: {
      props: [],
      aparatus: [],
      specialities: [],
    },
  }),
  methods: {
    toggleMenu() {
      this.menuOpen=!this.menuOpen;
      if (!this.menuOpen)
        this.$refs.mobileMenu.menuSubOpen=null;
    },
    openSubMenu($event, index) {
      if (this.menuSubOpen===index)
        return;
      if (!this.menuItems[index].sub)
        return;
      $event.preventDefault();
      this.menuSubOpen=index;
    },
    async loadTypes() {
      var perParent={};
      for(var type of videoTypes) {
        if (type.parent) {
          perParent[type.parent]=perParent[type.parent] || [];
          var item={
            link: {name: "category", params: {category: type.slug}},
            title: type.title,
            sub: [],
          };
          perParent[type.parent].push(item);
          for(var type2 of videoTypes) {
            if (type2.parent==type.id)
              item.sub.push({
                link: {name: "category", params: {category: type2.slug}},
                title: type2.title,
              });
          }
        } 
      }
      for(var menuItem of this.menuItems) {
        var menuType=null;
        for(var type of videoTypes) {
          if (menuItem.link.params && type.slug==menuItem.link.params.category)
            menuType=type;
        }
        if (menuType)
          this.$set(menuItem, "sub", perParent[menuType.id]);
      }
      for(var parentId in perParent || {}) {
        if (this.menuItems[parentId==4?5:parentId*1])
        this.$set(this.menuItems[parentId==4?5:parentId*1], "sub", perParent[parentId]);
      }
      await this.loadGroups();
    },
    menuItemForType(type) {
      var rootType=type;
      while(rootType && rootType.parent) {
        var parentType=videoTypes.find(a=>a.id==rootType.parent);
        if (parentType)
          rootType=parentType;
        else
          rootType={...rootType, parent: null};
      }
      for(var item of this.menuItems) {
        if (item.link.params && item.link.params.category==rootType.slug) {
          return item;
        }
      }
      return null;
    },
    async loadGroups() {
      var items=(await api.list("Video", {subtitle: ["!=", ""]}, ["created:DESC"])).items;
      for(var item of items) {
        if (item.subtitle[0]!=" ")
          continue;
        var menuItem=this.menuItemForType(item.type);
        if (menuItem) {
          menuItem.sub.push({
            link: {name: "content", params: {id: item.id}},
            title: item.subtitle,
          });
        }
      }
    },
    async loadTags() {
    },
    isActive(item) {
      if (this.$route.name=='category' && item.link.name=='category' && this.$route.params.category==item.link.params.category)
        return true;
      if (this.$route.name=='packages' && item.link.name=='packages')
        return true;
      if (item.link.name=='home' && 
          this.$route.name!='category' && 
          this.$route.name!='packages')
        return true;
      return false;
    },
  },
  mounted() {
    this.loadTypes();
  },
}
